<div class="account-deactivated">
  <h1>Account deactivated</h1>
  <p>Your account no longer has access to the Portal.</p>
  <p>If you believe this is a mistake, please contact support.</p>
  <button type="button" class="btn btn-primary" (click)="backToSignIn()">Back to sign in</button>
</div>
